import {createSelector} from '@reduxjs/toolkit';

import {ApplicationStoreType} from 'desktop/store';
import {AddressItemType, AddressType} from 'desktop/types/addressType';

import {RecurlyFieldsType} from 'desktop/types/recurlyTypes';

import {MODULE_KEY_CHECKOUT} from '../constants';

/**
 * Get list of customer billing addresses
 *s
 * @param {ApplicationStoreType} store - current store
 * @return {AddressType} list of billing addresses
 */
export const getBillingAddress = (store: ApplicationStoreType): AddressType =>
    store[MODULE_KEY_CHECKOUT].deliveryStep.billingAddress;

/**
 * Returns shipping address state
 *
 * @param {ApplicationStoreType} store - current store
 * @return {string} currently selected state
 */
export const getBillingAddressStateName = createSelector(
    getBillingAddress,
    (billingAddress: AddressType): string => billingAddress.state.value,
);

/**
 * Return full customer name from billing address
 *
 * @param {ApplicationStoreType} store - current store
 * @returns {AddressType} Customer's full name
 */
export const getCustomerName = createSelector(getBillingAddress, ({firstName, lastName}) => {
    const getValue = (nameItem: AddressItemType) => nameItem?.value || '';
    return `${getValue(firstName)} ${getValue(lastName)}`.trim();
});

/**
 * Returns shipping address state
 *
 * @param {ApplicationStoreType} store - current store
 * @return {RecurlyFieldsType} currently selected state
 */
export const getBillingAddressForRecurly = createSelector(
    getBillingAddress,
    getBillingAddressStateName,
    (billing: AddressType, state): RecurlyFieldsType => ({
        address1: billing.address.value,
        city: billing.city.value,
        country: billing.country.value,
        first_name: billing.firstName.value,
        last_name: billing.lastName.value,
        postal_code: billing.postal.value,
        state,
    }),
);
